<template>
    <v-menu v-if="value.length">
        <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" block>
                <div class="text-subtitle-2 text-capitalize">
                        {{ wishlist.name || wishlist.id }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="caption">
                        {{ wishlist.private ? 'private' : 'public' }}
                    </div>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="(item, i) in value" :value="item" :key="item.id" @change="index = i" dense>
                <v-btn block plain small @click="menuClick(i)" class="px-0">
                    <div class="text-subtitle-2 text-capitalize">
                        {{ item.name || item.id }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="caption">
                        {{ item.private ? 'private' : 'public' }}
                    </div>
                </v-btn>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<style scoped></style>
<script>
import {} from '@mdi/js';

export default {
    name: 'BnftWishlistMenu',
    props: {
        value: Array,
    },
    computed: {
        wishlist() { return this.value[this.index] || {} }
    },
    methods: {
        menuClick(index) {
            this.$emit('change', index);
        },
    },
    data: function () {
        return {
            index: 0
        };
    },
    mounted() {
        console.log(this.value)
    },
};
</script>
